<template>
  <!-- CRM replica of the client Contact step (StepContactDetails.vue). The form
       fields come from Nezasa's field config; profile-configurable are only the
       forced-required Mobile flag and the per-field notes, both shown live. -->
  <div class="step-contact">
    <h2 class="step-title">{{ t('checkout_contact_title', 'Contact Details') }}</h2>
    <p class="step-subtitle">{{ t('checkout_contact_subtitle', 'Please provide the main contact information for this booking.') }}</p>

    <div class="form-grid">
      <div v-for="f in fields" :key="f.key" class="form-group" :class="{ 'form-group--full': f.key === 'address1' }">
        <label>
          {{ t(f.langKey, f.fallback) }}
          <span v-if="isRequired(f.key)" class="req">*</span>
        </label>
        <span class="form-field-placeholder"></span>
        <p v-if="noteFor(f.key)" class="field-note">{{ noteFor(f.key) }}</p>
      </div>
    </div>

    <div class="step-actions">
      <button class="checkout-btn checkout-btn--primary" :style="{ backgroundColor: brandColor }">{{ t('checkout_next', 'Next') }}</button>
    </div>
  </div>
</template>

<script>
import previewLang from './previewLang';
import { CONTACT_NOTE_FIELDS, contactNoteKey } from '../contactNoteFields';

// Fields Nezasa typically marks required — purely for a representative preview;
// the live step takes this from the checkout's field config.
const SAMPLE_REQUIRED = ['gender', 'firstName', 'lastName', 'email', 'phone', 'address1', 'postalCode', 'city', 'country'];

export default {
  name: 'ContactPreview',
  mixins: [previewLang],
  props: {
    texts: { type: Object, default: () => ({}) },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' },
    boxVisibility: { type: Object, default: () => ({}) }
  },
  computed: {
    fields() { return CONTACT_NOTE_FIELDS; },
    mobileRequired() {
      return this.boxVisibility.contact_mobile_required === true || this.boxVisibility.contact_mobile_required === 1;
    }
  },
  methods: {
    isRequired(key) {
      if (key === 'mobilePhone') return this.mobileRequired;
      return SAMPLE_REQUIRED.includes(key);
    },
    noteFor(key) {
      const v = this.texts && this.texts[contactNoteKey(key)];
      return v ? String(v) : '';
    }
  }
};
</script>

<style scoped>
.step-title { font-size: 20px; font-weight: 700; margin: 0 0 6px; }
.step-subtitle { font-size: 13px; color: #666; margin: 0 0 24px; }

.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.form-group { display: flex; flex-direction: column; }
.form-group--full { grid-column: 1 / -1; }
.form-group label { font-size: 13px; font-weight: 600; margin-bottom: 4px; color: #333; }
.req { color: #e74c3c; }

.form-field-placeholder {
  display: block; height: 36px;
  border: 1px dashed #e0e0e0; border-radius: 4px; background: #fafafa;
}

.field-note { font-size: 12px; color: #888; line-height: 1.4; margin: 4px 0 0; }

.step-actions { margin-top: 28px; display: flex; justify-content: flex-end; }
.checkout-btn { padding: 10px 28px; border: none; border-radius: 4px; font-size: 14px; font-weight: 600; color: #fff; }
</style>
